// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wPd0","col":"styles_col__3ZMbD","actions":"styles_actions__2pyif","conflict":"styles_conflict__2uF3r"};